import src from "IMAGE";
export default { src, width: 504, height: 504, blurWidth: 0, blurHeight: 0};
